module.exports = __webpack_public_path__ + "img/home_suyuan.c40e3da0.png";